import { render, staticRenderFns } from "./DetallePuntoEntrega.vue?vue&type=template&id=44b90b4e&scoped=true"
import script from "./DetallePuntoEntrega.vue?vue&type=script&lang=js"
export * from "./DetallePuntoEntrega.vue?vue&type=script&lang=js"
import style0 from "./DetallePuntoEntrega.vue?vue&type=style&index=0&id=44b90b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b90b4e",
  null
  
)

export default component.exports